import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-26-karthikeyan-palanisamy-guest.webp";
import ThumbImg from "../../assets/images/conversations/026.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: kp2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .kp2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .kp2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .kp2-hero { padding-top: 60px; padding-bottom: 60px; }
  .kp2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .kp2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .kp2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kp2-hero__title.kp2-visible { opacity: 1; transform: translateY(0); }
  .kp2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .kp2-hero__spotify.kp2-visible { opacity: 1; transform: translateY(0); }
  .kp2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .kp2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .kp2-hero__right.kp2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .kp2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .kp2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .kp2-yt-thumb:hover img { opacity: 0.85; }
  .kp2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .kp2-yt-thumb__play img { width: 40px; height: 44px; }
  .kp2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .kp2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .kp2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kp2-body.kp2-visible { opacity: 1; transform: translateY(0); }
  .kp2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .kp2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .kp2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kp2-guest.kp2-visible { opacity: 1; transform: translateY(0); }
  .kp2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .kp2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .kp2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .kp2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .kp2-inner { padding-left: 32px; padding-right: 32px; }
    .kp2-hero { padding-top: 32px; padding-bottom: 48px; }
    .kp2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .kp2-hero__title { font-size: 24px; }
    .kp2-hero__left { gap: 16px; }
    .kp2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .kp2-guest__photo-bg { width: 260px; height: 300px; }
    .kp2-guest__name { font-size: 24px; margin-top: 18px; }
    .kp2-body__para { font-size: 14px; margin-bottom: 12px; }
    .kp2-body { padding-bottom: 48px; }
    .kp2-guest { padding-bottom: 48px; }
    .kp2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .kp2-inner { padding-left: 16px; padding-right: 16px; }
    .kp2-hero { padding-top: 51px; padding-bottom: 30px; }
    .kp2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .kp2-hero__left { gap: 30px; }
    .kp2-hero__title { font-size: 30px; }
    .kp2-body__para { font-size: 16px; margin-bottom: 10px; }
    .kp2-guest__title { font-size: 30px; margin-bottom: 20px; }
    .kp2-guest__photo-bg { width: 100%; height: 386px; }
    .kp2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .kp2-body { padding-bottom: 30px; }
    .kp2-guest { padding-bottom: 30px; }
    .kp2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("kp2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP26_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="kp2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 26 Karthikeyan Palanisamy Zeon Charging"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="kp2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 26 Karthikeyan Palanisamy thumbnail" />
      <div className="kp2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="kp2-hero">
      <div className="kp2-inner">
        <div className="kp2-hero__grid">
          <div className="kp2-hero__left">
            <h1 ref={titleRef} className="kp2-hero__title">
              EP 26 | Electrifying South India | Karthikeyan Palanisamy | Zeon Charging
            </h1>
            <div ref={spotifyRef} className="kp2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4vv8yoabJ5Qj487UyiYOIG?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 26 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="kp2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="kp2-body">
      <div className="kp2-inner">
        <p className="kp2-body__para">
          Today we speak with one of the most interesting startups started in South India. A fast-growing charge point operations company, in fact, given to its pace of growth, the company can perhaps no longer be called a startup. Zeon Charging is rapidly building the infrastructure needed to enable the EV Revolution in India. We speak with Karthikeyan Palanisamy, CEO and Co-founder of Zeon Charging.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="kp2-guest">
      <div className="kp2-inner">
        <h2 className="kp2-guest__title">Our Guest</h2>
        <div>
          <div className="kp2-guest__photo-bg">
            <img src={GuestImg} alt="Karthikeyan Palanisamy" />
          </div>
          <p className="kp2-guest__name">Karthikeyan PALANISAMY</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep26KarthikeyanPalanisamy() {
  return (
    <>
      <style>{CSS}</style>
      <div className="kp2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}